// CBSE IX Std.
export const defaultJson = [
  {
    "stepId": "basic Details",
    "stepName": "Student Information",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 1,
    "stepType": "form",
    "sections": [
      {
        "sectionName": "Basic Details",
        "apiKeyId": "applicant",
        "subSectionName": "",
        "sectionPosition": 1,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "fieldId": "applicant[firstName]",
            "required": true,
            "name": "applicant[firstName]",
            "label": "First Name",
            "type": "input",
            "disabled": true,
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid First Name"
              },
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            }
          },
          {
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "fieldId": "applicant[lastName]",
            "required": true,
            "name": "applicant[lastName]",
            "label": "Last Name",
            "disabled": true,
            "type": "input",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid First Name"
              },
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            }
          },
          {
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "fieldId": "applicant[dateOfBirth]",
            "required": true,
            "name": "applicant[dateOfBirth]",
            "label": "Date of Birth",
            "type": "date",
            "minDate": "2000-01-01",
            "validations": {
              "required": "This field is required"
            }
          },
          {
            "fieldId": "applicant[nationality]",
            "required": true,
            "name": "applicant[nationality]",
            "label": "Nationality",
            "type": "autocomplete",
            "metaData": {
              "optionsKey": "nationality"
            },
            "options": [],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "fieldId": "applicant[birthPlace]",
            "required": false,
            "name": "applicant[birthPlace]",
            "label": "Place of Birth",
            "type": "input",
            "validations": {
              "maxLength": {
                "value": 20,
                "message": "This field cannot be more than 20 characters"
              }
            }
          },
          {
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "fieldId": "applicant[gender]",
            "required": true,
            "name": "applicant[gender]",
            "label": "Gender",
            "type": "select",
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "Male",
                "value": "Male"
              },
              {
                "label": "Female",
                "value": "Female"
              },
              {
                "label": "Decline to State",
                "value": "Decline to State"
              }
            ]
          },
          {
            "fieldId": "applicant[motherTongue]",
            "required": true,
            "name": "applicant[motherTongue]",
            "label": "Mother Tongue",
            "type": "select",
            "metaData": {
              "optionsKey": "language"
            },
            "options": [],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicant[motherTongueOthers]",
            "required": true,
            "name": "applicant[motherTongueOthers]",
            "label": "Mother Tongue Other",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 80,
                "message": "This field cannot be more than 80 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[motherTongue]",
                "expectedValue": "Others",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "fieldId": "applicant[firstLanguage]",
            "required": true,
            "name": "applicant[firstLanguage]",
            "label": "1st Language",
            "type": "input",
            "disabled": true,
            "validations": {
              "required": "This field is required"
            }
          },
          {
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "fieldId": "application[birthCertificate]",
            "required": true,
            "name": "application[birthCertificate]",
            "label": "Transfer Certificate/Birth Certificate",
            "type": "select",
            "apiKey": "application[birthCertificate]",
            "options": [
              {
                "label": "Transfer Certificate",
                "value": "Transfer Certificate"
              },
              {
                "label": "Birth Certificate",
                "value": "Birth Certificate"
              }
            ],
            "validationType": "aplha",
            "validations": {
              "required": "This field is required"
            }
          },
          {
            "fieldId": "applicant[tcNumber]",
            "required": false,
            "name": "applicant[tcNumber]",
            "label": "Transfer Certificate Number",
            "type": "input",
            "disabled": false,
            "validations": {
              "maxLength": {
                "value": 20,
                "message": "This field cannot be more than 20 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[birthCertificate]",
                "expectedValue": "Transfer Certificate",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicant[tcdate]",
            "name": "applicant[tcdate]",
            "required": false,
            "label": "Transfer Certificate Date",
            "type": "date",
            "maxDate": true,
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[birthCertificate]",
                "expectedValue": "Transfer Certificate",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicant[phone]",
            "required": true,
            "name": "applicant[phone]",
            "label": "Phone Number",
            "type": "phone",
            "apiKey": "applicant[phone]",
            "disabled": true,
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Phone Number"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicant[email]",
            "required": true,
            "name": "applicant[email]",
            "label": "Email",
            "disabled": true,
            "type": "input",
            "validationType": "email",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Email"
              },
              "maxLength": {
                "value": 50,
                "message": "This field cannot be more than 50 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicant[aadharNumber]",
            "name": "applicant[aadharNumber]",
            "label": "Aadhaar Number",
            "type": "input",
            "required": true,
            "validationType": "number",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 12,
                "message": "Aadhaar number must be 12 digits only"
              },
              "minLength": {
                "value": 12,
                "message": "Aadhaar number must be 12 digits only"
              },
              "pattern": {
                "value": "",
                "message": "Please enter valid aadhaar number"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          }
        ]
      }
    ]
  },
  {
    "stepId": "familyInfo",
    "stepName": "Family Information",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 2,
    "stepType": "form",
    "sections": [
      {
        "sectionId": "familyInformation",
        "sectionName": "Family Information",
        "subSectionName": "",
        "sectionPosition": 2,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "applicantRelations[0][relationshipType]",
            "required": true,
            "name": "applicantRelations[0][relationshipType]",
            "validations": {
              "required": "This field is required"
            },
            "label": "Relationship With Applicant",
            "type": "select",
            "options": [
              {
                "label": "Father",
                "value": "Father"
              }
            ],
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[0][firstName]",
            "required": true,
            "name": "applicantRelations[0][firstName]",
            "label": "First Name",
            "type": "input",
            "validationType": "alpha",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid First Name"
              },
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[0][lastName]",
            "required": true,
            "name": "applicantRelations[0][lastName]",
            "label": "Last Name",
            "type": "input",
            "validationType": "alpha",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Last Name"
              },
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[0][birthPlace]",
            "required": false,
            "name": "applicantRelations[0][birthPlace]",
            "label": "Place Of Birth",
            "type": "input",
            "validationType": "alpha",
            "validations": {
              "maxLength": {
                "value": 20,
                "message": "This field cannot be more than 20 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[0][occupation]",
            "required": true,
            "name": "applicantRelations[0][occupation]",
            "label": "Occupation",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[0][annualIncome]",
            "name": "applicantRelations[0][annualIncome]",
            "label": "Annual Income",
            "type": "input",
            "validationType": "number",
            "validations": {
              "pattern": {
                "value": "",
                "message": "Please Input a valid value"
              },
              "maxLength": {
                "value": 20,
                "message": "This field cannot be more than 20 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[0][aadharNumber]",
            "name": "applicantRelations[0][aadharNumber]",
            "label": "Aadhaar Number",
            "type": "input",
            "required": true,
            "validationType": "number",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 12,
                "message": "Aadhaar number must be 12 digits only"
              },
              "minLength": {
                "value": 12,
                "message": "Aadhaar number must be 12 digits only"
              },
              "pattern": {
                "value": "",
                "message": "Please enter valid aadhaar number"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[0][mobilephone]",
            "name": "applicantRelations[0][mobilephone]",
            "label": "Mobile",
            "required": true,
            "type": "phone",
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[0][email]",
            "name": "applicantRelations[0][email]",
            "label": "Email",
            "type": "input",
            "required": true,
            "validationType": "email",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Email"
              },
              "maxLength": {
                "value": 50,
                "message": "This field cannot be more than 50 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[0][designationAddress]",
            "name": "applicantRelations[0][designationAddress]",
            "label": "Designation and Occupational Address",
            "type": "input",
            "required": false,
            "validations": {
              "maxLength": {
                "value": 200,
                "message": "This field cannot be more than 200 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          }
        ]
      },
      {
        "sectionId": "familyInformation",
        "sectionName": "",
        "summaryName": "Relation Information",
        "subSectionName": "",
        "sectionPosition": 2,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "applicantRelations[1][relationshipType]",
            "required": true,
            "name": "applicantRelations[1][relationshipType]",
            "validations": {
              "required": "This field is required"
            },
            "label": "Relationship With Applicant",
            "type": "select",
            "options": [
              {
                "label": "Mother",
                "value": "Mother"
              }
            ],
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[1][firstName]",
            "required": true,
            "name": "applicantRelations[1][firstName]",
            "label": "First Name",
            "type": "input",
            "validationType": "alpha",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid First Name"
              },
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[1][lastName]",
            "required": true,
            "name": "applicantRelations[1][lastName]",
            "label": "Last Name",
            "type": "input",
            "validationType": "alpha",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Last Name"
              },
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[1][birthPlace]",
            "required": false,
            "name": "applicantRelations[1][birthPlace]",
            "label": "Place Of Birth",
            "type": "input",
            "validationType": "alpha",
            "validations": {
              "maxLength": {
                "value": 20,
                "message": "This field cannot be more than 20 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[1][occupation]",
            "required": true,
            "name": "applicantRelations[1][occupation]",
            "label": "Occupation",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[1][annualIncome]",
            "name": "applicantRelations[1][annualIncome]",
            "label": "Annual Income",
            "type": "input",
            "validationType": "number",
            "validations": {
              "pattern": {
                "value": "",
                "message": "Please Input a valid value"
              },
              "maxLength": {
                "value": 20,
                "message": "This field cannot be more than 20 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[1][aadharNumber]",
            "name": "applicantRelations[1][aadharNumber]",
            "label": "Aadhaar Number",
            "type": "input",
            "required": true,
            "validationType": "number",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 12,
                "message": "Aadhaar number must be 12 digits only"
              },
              "minLength": {
                "value": 12,
                "message": "Aadhaar number must be 12 digits only"
              },
              "pattern": {
                "value": "",
                "message": "Please enter valid aadhaar number"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[1][mobilephone]",
            "name": "applicantRelations[1][mobilephone]",
            "label": "Mobile",
            "required": true,
            "type": "phone",
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[1][email]",
            "name": "applicantRelations[1][email]",
            "label": "Email",
            "type": "input",
            "required": true,
            "validationType": "email",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Email"
              },
              "maxLength": {
                "value": 50,
                "message": "This field cannot be more than 50 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[1][designationAddress]",
            "name": "applicantRelations[1][designationAddress]",
            "label": "Designation and Occupational Address",
            "type": "input",
            "required": false,
            "validations": {
              "maxLength": {
                "value": 200,
                "message": "This field cannot be more than 200 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          }
        ]
      },
      {
        "sectionId": "familyInformation",
        "sectionName": "",
        "summaryName": "Guardian Information",
        "subSectionName": "",
        "sectionPosition": 2,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "applicant[guardian]",
            "name": "applicant[guardian]",
            "label": "Do you have a local guardian?",
            "type": "select",
            "required": true,
            "options": [
              {
                "label": "Yes",
                "value": "Yes"
              },
              {
                "label": "No",
                "value": "No"
              }
            ],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][relationshipType]",
            "name": "applicantRelations[2][relationshipType]",
            "label": "Relationship With Applicant",
            "type": "select",
            "required": true,
            "options": [
              {
                "label": "Guardian",
                "value": "Guardian"
              }
            ],
            "validations": {
              "required": "This field is required"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][firstName]",
            "name": "applicantRelations[2][firstName]",
            "label": "First Name",
            "type": "input",
            "required": true,
            "validationType": "alpha",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid First Name"
              },
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][lastName]",
            "name": "applicantRelations[2][lastName]",
            "label": "Last Name",
            "type": "input",
            "required": true,
            "validationType": "alpha",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Last Name"
              },
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][birthPlace]",
            "required": false,
            "name": "applicantRelations[2][birthPlace]",
            "label": "Place Of Birth",
            "type": "input",
            "validationType": "alpha",
            "validations": {
              "maxLength": {
                "value": 20,
                "message": "This field cannot be more than 20 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][occupation]",
            "name": "applicantRelations[2][occupation]",
            "label": "Occupation",
            "type": "input",
            "validations": {
              "maxLength": {
                "value": 40,
                "message": "This field cannot be more than 40 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][annualIncome]",
            "name": "applicantRelations[2][annualIncome]",
            "label": "Annual Income",
            "type": "input",
            "validationType": "number",
            "validations": {
              "pattern": {
                "value": "",
                "message": "Please Input a valid value"
              },
              "maxLength": {
                "value": 20,
                "message": "This field cannot be more than 20 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][aadharNumber]",
            "name": "applicantRelations[2][aadharNumber]",
            "label": "Aadhaar Number",
            "type": "input",
            "validationType": "number",
            "validations": {
              "maxLength": {
                "value": 12,
                "message": "Aadhaar number must be 12 digits only"
              },
              "minLength": {
                "value": 12,
                "message": "Aadhaar number must be 12 digits only"
              },
              "pattern": {
                "value": "",
                "message": "Please enter valid aadhaar number"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][mobilephone]",
            "name": "applicantRelations[2][mobilephone]",
            "label": "Mobile",
            "type": "phone",
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][email]",
            "name": "applicantRelations[2][email]",
            "label": "Email",
            "type": "input",
            "validationType": "email",
            "validations": {
              "pattern": {
                "value": "",
                "message": "Please Input a valid Email"
              },
              "maxLength": {
                "value": 50,
                "message": "This field cannot be more than 50 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicantRelations[2][designationAddress]",
            "name": "applicantRelations[2][designationAddress]",
            "label": "Designation and Occupational Address",
            "type": "input",
            "required": false,
            "validations": {
              "maxLength": {
                "value": 200,
                "message": "This field cannot be more than 200 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[guardian]",
                "expectedValue": "Yes",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          }
        ]
      }
    ]
  },
  {
    "stepId": "basic Details",
    "stepName": "Address Details",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 3,
    "stepType": "form",
    "sections": [
      {
        "sectionName": "Addresses",
        "subSectionName": "",
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "name": "applicant",
            "type": "address",
            "options": [
              {
                "fieldId": "mailingCountry",
                "required": true,
                "name": "mailingCountry",
                "isPartOfCollection": true,
                "label": "Country",
                "type": "autocomplete",
                "value": "India",
                "validations": {
                  "required": "This field is required"
                }
              },
              {
                "fieldId": "mailingState",
                "required": true,
                "name": "mailingState",
                "label": "State",
                "type": "autocomplete",
                "validations": {
                  "required": "This field is required"
                },
                "options": []
              },
              {
                "fieldId": "mailingDistrict",
                "required": true,
                "name": "mailingDistrict",
                "label": "District/City",
                "type": "autocomplete",
                "validations": {
                  "required": "This field is required"
                },
                "options": []
              }
            ],
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicant[mailingDistrictOthers]",
            "required": true,
            "name": "applicant[mailingDistrictOthers]",
            "label": "District/City Others",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": 1,
                "message": "This field cannot be less than 1 character"
              },
              "maxLength": {
                "value": 50,
                "message": "This field cannot be more than 50 characters"
              },
              "pattern": {
                "value": "",
                "message": "Please Enter A Valid District Name"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "addresses[0][mailingDistrict]",
                "expectedValue": "Others",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicant[mailingPostalCode]",
            "required": true,
            "name": "applicant[mailingPostalCode]",
            "label": "PIN / PO BOX/ ZIP",
            "type": "input",
            "validationType": "number",
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": 6,
                "message": "Please Enter A Valid Pincode"
              },
              "maxLength": {
                "value": 6,
                "message": "Please Enter A Valid Pincode"
              },
              "pattern": {
                "value": "",
                "message": "Please Enter A Valid Pincode"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "applicant[mailingStreet]",
            "required": true,
            "name": "applicant[mailingStreet]",
            "label": "Address",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": 1,
                "message": "This field cannot be less than 1 character"
              },
              "maxLength": {
                "value": 250,
                "message": "This field cannot be more than 250 characters"
              },
              "pattern": {
                "value": "",
                "message": "Please Enter A Valid Address"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          }
        ]
      }
    ]
  },
  {
    "stepId": "basic Details",
    "stepName": "Education History",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 5,
    "stepType": "form",
    "sections": [
      {
        "apiKeyId": "application",
        "sectionName": "Student Educational details",
        "sectionId": "application",
        "subSectionName": "",
        "sectionPosition": 1,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "educationHistories[0][institutionName]",
            "required": true,
            "name": "educationHistories[0][institutionName]",
            "label": "Educational Institution Name",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 50,
                "message": "This field cannot be more than 50 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "educationHistories[0][location]",
            "required": true,
            "name": "educationHistories[0][location]",
            "label": "Location of institute",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 200,
                "message": "This field cannot be more than 200 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "educationHistories[0][lastStudied]",
            "required": true,
            "name": "educationHistories[0][lastStudied]",
            "label": "Previous Class/Grade Studied",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 150,
                "message": "This field cannot be more than 150 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            }
          },
          {
            "fieldId": "educationHistories[0][details]",
            "required": false,
            "name": "educationHistories[0][details]",
            "label": "Details",
            "type": "textArea",
            "rows": 4,
            "validationType": "string",
            "validations": {
              "maxLength": {
                "value": 300,
                "message": "This field cannot be more than 300 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 12,
                "lg": 12
              }
            }
          }
        ]
      }
    ]
  },
  {
    "stepId": "Upload Documents",
    "stepName": "Photo & Document Upload",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 6,
    "stepType": "documentUpload",
    "sections": [
      {
        "sectionName": "Documents Upload",
        "apiKeyId": "applicant",
        "sectionId": "documentUpload",
        "subSectionName": "",
        "sectionPosition": 1,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": []
      }
    ]
  },
  {
    "stepId": "declaration",
    "stepName": "Declaration",
    "stepPosition": 7,
    "showStepName": true,
    "stepVisible": true,
    "stepType": "declaration",
    "voucher": true,
    "sections": []
  },
  {
    "stepId": "payment",
    "stepName": "Payment",
    "stepPosition": 4,
    "showStepName": true,
    "stepVisible": true,
    "stepType": "payment",
    "voucher": true,
    "sections": []
  },
  {
    "stepId": "summaryWithDeclaration",
    "stepName": "Summary",
    "stepPosition": 8,
    "showStepName": true,
    "stepVisible": true,
    "stepType": "summary",
    "voucher": true,
    "sections": []
  }
];

export const commonJson = {
  stepId: 'basic Details',
  stepName: 'Program Selection',
  showStepName: false,
  stepVisible: true,
  stepPosition: 1,
  stepType: 'form',
  sections: [
    {
      sectionName: 'Program Selection',
      apiKeyId: 'applicant',
      subSectionName: '',
      sectionPosition: 1,
      sectionVisible: true,
      sectionType: 'form',
      fields: [
        {
          ui: {
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
            },
          },
          fieldId: 'application[appliedProgram]',
          required: true,
          name: 'application[appliedProgram]',
          label: 'Select Branch',
          type: 'select',
          metaData: {
            optionsKey: 'programs',
          },
          options: [],
          validations: {
            required: 'This field is required',
          },
        },
        {
          ui: {
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
            },
          },
          fieldId: 'application[programId]',
          required: true,
          name: 'application[programId]',
          label: 'Select Class',
          type: 'select',
          metaData: {
            optionsKeyGet: 'application[appliedProgram]',
          },
          options: [],
          validations: {
            required: 'This field is required',
          },
        },
      ],
    },
  ],
};
